/** "1996년 4월 12일 (양력)" / "1995년 8월 10일 (음력 윤달)" */
export function formatBirthDate({ birthDate, calendarType, isLeapMonth }) {
    const [year, month, day] = birthDate.split('-').map(Number);
    let calendarLabel = '양력';
    if (calendarType === 'lunar') {
        calendarLabel = isLeapMonth ? '음력 윤달' : '음력';
    }
    return `${year}년 ${month}월 ${day}일 (${calendarLabel})`;
}

/** "오전 7:30" / "모름" */
export function formatBirthTime({ birthTime, timeUnknown }) {
    if (timeUnknown || !birthTime) {
        return '모름';
    }
    const [hour, minute] = birthTime.split(':').map(Number);
    const period = hour < 12 ? '오전' : '오후';
    const displayHour = hour % 12 === 0 ? 12 : hour % 12;
    return `${period} ${displayHour}:${String(minute).padStart(2, '0')}`;
}
